/** Format a currency amount given the country code. US: "$10.00" ; HT: "10 HTG" ; default: code suffix */
export function formatCurrency(amount, currencyCode = "USD") {
    const n = Number(amount || 0);
    if (currencyCode === "USD")
        return `$${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    return `${n.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} ${currencyCode}`;
}

export function formatDate(iso, locale = "en-US") {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        return d.toLocaleDateString(locale, {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    } catch {
        return iso;
    }
}

export function formatDateTime(iso, locale = "en-US") {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        return d.toLocaleString(locale, {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return iso;
    }
}

export function formatTime(iso, locale = "en-US") {
    if (!iso) return "";
    try {
        return new Date(iso).toLocaleTimeString(locale, {
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return "";
    }
}

export function isPastDate(iso) {
    try {
        return new Date(iso).getTime() < Date.now();
    } catch {
        return false;
    }
}

export function cn(...args) {
    return args.filter(Boolean).join(" ");
}
